import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "../components/LoadingSpinner";
import MainTitle from "../components/MainTitle";
import { formatPrice } from "../utils/format";

const PurchaseSuccess = () => {

    const navigate = useNavigate();
    const { payment_id } = useParams();

    const [purchase, setPurchase] = useState();
    const [loading, setLoading] = useState(true);
    const [freeDelivery, setFreeDelivery] = useState(false);
    const [totalProducts, setTotalProducts] = useState(null);
    const [total, setTotal] = useState();

    //useEffect to get the purchase, including products, address and instance
    useEffect(() => {
        async function getPurchase() {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}purchase/payment-purchase/${payment_id}`);
                setPurchase(response.data);

                //if total quantity is >= Kilos number discount, then change applyDiscount to true
                let total_quantity = 0;
                let total_products = 0;
                for (let i = 0; i < response.data.purchasebags.length; i++) {
                    total_quantity += response.data.purchasebags[i].quantity;
                    total_products += response.data.purchasebags[i].product.currentPrice * response.data.purchasebags[i].quantity;
                }
                // if (total_quantity >= process.env.REACT_APP_KILOS_NUMBER_DISCOUNT) {
                setTotalProducts(total_products);
                if (total_products >= process.env.REACT_APP_FREE_DELIVERY_AMOUNT) {
                    setFreeDelivery(true);
                    setTotal(Number(total_products));
                } else {
                    setFreeDelivery(false);
                    setTotal(Number(total_products) + Number(process.env.REACT_APP_DELIVERY_FEE));
                }

                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        }
        getPurchase();
    }, []);


    if (loading) {
        return (
            <div className="min-h-screen bg-[#f6f6ee]">
                <MainTitle />
                <div className="flex justify-center py-16">
                    <LoadingSpinner />
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#f6f6ee] pb-10">

            {/* Header */}
            <MainTitle />

            {/* Confirmación */}
            <div className="px-4 pt-6 pb-1 text-center">
                <div className="w-14 h-14 rounded-full bg-[#2f5a2e] flex items-center justify-center mx-auto mb-3 shadow-md shadow-[#2f5a2e]/20">
                    <svg className="w-7 h-7 text-[#f4f3e6]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"/>
                    </svg>
                </div>
                <h1
                    className="font-serif text-[22px] font-bold text-[#1e2a1a] leading-tight"
                >
                    ¡Gracias por tu compra, {purchase.buyerName}!
                </h1>
                <p className="text-[12px] text-gray-400 mt-1">Tu pedido quedó confirmado</p>
            </div>

            {/* Separador */}
            <div className="flex items-center gap-3 px-4 my-5">
                <div className="flex-1 h-px bg-gray-200" />
                <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">detalle del pedido</span>
                <div className="flex-1 h-px bg-gray-200" />
            </div>

            <div className="flex flex-col gap-3">

                {/* Productos */}
                <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
                    <div className="px-4 py-3 flex items-center gap-2 bg-[#f6f6ee] border-b border-gray-100">
                        <svg className="w-4 h-4 text-[#4a7c2f] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
                        </svg>
                        <p className="text-sm font-semibold text-[#1e2a1a]">Productos</p>
                    </div>
                    <div className="px-4 py-2 divide-y divide-gray-50">
                        {purchase.purchasebags.map((purchasebag) => (
                            <div key={purchasebag.product.id} className="flex items-center justify-between gap-3 py-2.5">
                                <p className="text-[13px] text-[#1e2a1a] leading-tight">
                                    <span className="font-semibold">{purchasebag.quantity} x </span>
                                    {purchasebag.product.type} de {purchasebag.product.name}
                                </p>
                                <p className="text-[13px] font-semibold text-[#4a7c2f] whitespace-nowrap">
                                    {formatPrice(purchasebag.product.currentPrice * purchasebag.quantity)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Despacho */}
                <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
                    <div className="px-4 py-3 flex items-center gap-2 bg-[#f6f6ee] border-b border-gray-100">
                        <svg className="w-4 h-4 text-[#4a7c2f] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
                        </svg>
                        <p className="text-sm font-semibold text-[#1e2a1a]">Despacho</p>
                    </div>
                    <div className="px-4 py-3 flex flex-col gap-2">
                        <div>
                            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Día</p>
                            <p className="text-[13px] text-[#1e2a1a] font-medium">
                                {purchase.instance.dayName} {purchase.instance.dayNumber} de {purchase.instance.monthName}
                            </p>
                        </div>
                        <div>
                            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Dirección</p>
                            <p className="text-[13px] text-[#1e2a1a] font-medium">
                                {purchase.address.streetName} {purchase.address.streetNumber}{purchase.address.houseNumber ? ` (Casa ${purchase.address.houseNumber})` : ""}{purchase.address.houseNumber ? ` (Dpto ${purchase.address.departmentNumber})` : ""}, {purchase.address.commune}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Totales */}
                <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
                    <div className="px-4 py-3 flex flex-col gap-1.5">
                        <div className="flex items-center justify-between">
                            <span className="text-[13px] text-gray-500">Total productos</span>
                            <span className="text-[13px] font-medium text-[#1e2a1a]">{formatPrice(totalProducts)}</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span className="text-[13px] text-gray-500">Despacho</span>
                            {freeDelivery ? (
                                <span className="text-[11px] font-semibold text-[#4a7c2f] bg-[#edf4e0] px-2.5 py-0.5 rounded-full">gratis</span>
                            ) : (
                                <span className="text-[13px] font-medium text-[#1e2a1a]">{formatPrice(process.env.REACT_APP_DELIVERY_FEE)}</span>
                            )}
                        </div>
                        <div className="h-px bg-gray-100 my-1" />
                        <div className="flex items-center justify-between">
                            <span className="text-sm font-semibold text-[#1e2a1a]">Total pagado</span>
                            <span className="text-[17px] font-bold text-[#2f5a2e]">{formatPrice(total)}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Volver */}
            <div className="px-4 mt-6">
                <button
                    onClick={() => navigate("/")}
                    className="w-full py-3 rounded-xl text-sm font-semibold bg-[#2f5a2e] hover:bg-[#3f7a3a] active:scale-[0.98] text-[#f4f3e6] shadow-md shadow-[#2f5a2e]/20 transition-all duration-150"
                >
                    Volver al inicio
                </button>
            </div>
        </div>
    );
}

export default PurchaseSuccess;
